// @flow

import React, { useState } from 'react';
import classNames from 'classnames';
import { log } from '../../utils/jsUtils';
import { useStore } from '../../store';
import red from '@mui/material/colors/red';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import withStyles from '../../utils/withStyles';
import styles from './Styles/AddStaffDialog.Style';
import type { User, Building } from '../../services/SPBackend';

type Props = {
  handleRemovePropertyAccess: Function,
  classes: Object,
  setOpen: Function,
  open: boolean,
  building: Building,
  selectedStaff: User
};

// eslint-disable-next-line react/no-multi-comp
const RemoveProperty = (props: Props) => {
  const {
    classes,
    setOpen,
    open,
    handleRemovePropertyAccess,
    selectedStaff,
    building
  } = props;

  const [store] = useStore();
  const {
    i18n
  } = store;

  const [staff, setStaff] = useState({
    Email: '',
    Permissions: {
      Properties: []
    }
  });

  return (
    <div>
    {
      (staff !== null) && (building !== null)
      ? <Dialog
          aria-labelledby='form-add-property'
          onClose={() => setOpen(false)}
          onEnter={() =>
            setStaff(
              {
                Email: selectedStaff.Email,
                Permissions: {
                  Properties: building !== null ? [building.PropertyKey] : []
                }
              }
            )
          }
          open={open}
        >
          <DialogTitle id='form-dialog-title'>
          {'HEADS UP!'}
          </DialogTitle>
          <DialogContent className={classNames(classes.grow, classes.flexContainer)}>
            <DialogContentText>
              {`You are about to remove access to this ${i18n.t('property')}:`}<br />
              <b style={{color: red[600]}}>{`${building.Property}`}</b><br /><br />
              {'Are you sure?'}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button color='primary'
              onClick={() => setOpen(false)}
            >
              {'Cancel'}
              </Button>
            <Button 
              color='primary'
              onClick={() => {
                log('[removePropertyAccessDialog] setStaff', staff);
                handleRemovePropertyAccess(staff); 
                setOpen(false); 
              }}
              variant='contained'
            >
              {'Remove'}
              </Button>
          </DialogActions>
        </Dialog>
      : null
    }
    </div>
  );
};

export default withStyles(styles)(RemoveProperty);